import axios from "../index"

// 接口基础路径
const rootApi = '/api_v2'

/** 设备登录 */
export const deviceLogin = (params) => {
  return axios.post(`/terminal/deviceLogin`, params)
}

/** 获取工位信息 */
export const getStationInfo = () => {
  return axios.get(`${rootApi}/stationInfo`)
}

/** 用户登录 */
export const userLogin = (params) => {
  return axios.post(`${rootApi}/mesLogin`, params)
}

/** 验证员工码 */
export const validUserId = (userId) => {
  return axios.post(`${rootApi}/validUserId/${userId}`)
}

/** 验证登录用户账号密码 */
export const validUser = (params) => {
  return axios.post(`${rootApi}/validUser`, params)
}

/** 基础配置 */
export const basicConfig = () => {
  return axios.get(`${rootApi}/basicConfig`)
}

/** 终端模块定义 */
export const terminalDefine = () => {
  return axios.get(`${rootApi}/define/terminal`)
}

/** 系统模块定义 */
export const systemDefine = () => {
  return axios.get(`${rootApi}/define/system`)
}

/** 终端异常状态 */
export const terminalAbnormal = () => {
  return axios.get(`${rootApi}/terminalAbnormal`, {hide: true})
}

/** 根据id卡获得登录信息 */
export const getLoginInfo = (idCode) => {
  return axios.post(`${rootApi}/mesLogin/${idCode}`)
}
